import React from 'react';
import { Box } from '@curves/ui-base';

const TestPage = () => {
    return (
        <Box className={'main-container-spacing'}>
            <h1>Test Page</h1>
        </Box>
    );
};
export default TestPage;
